/** The private Supabase Storage buckets. Must match the CHECK on `assets.bucket`. */
export enum AssetBucket {
  SourceDocuments = 'source-documents',
  QuestionAssets = 'question-assets',
  ResponseFiles = 'response-files',
}
